import './index.scss'
$("#nav5").addClass("active");
$(".out").click(function() {
    $(".pop").removeClass("active");
})
$(".question-list li").click(function() {
    let index = $(this).index();
    $(".pop-list .pop").eq(index).addClass("active");
})